import {
	Button, Dialog, DialogActions, DialogContent,
	DialogContentText, DialogTitle, IconButton, Tooltip,
} from "@material-ui/core";

import React from "react";
import RemoveIcon from '@material-ui/icons/RemoveCircle';

const RemoveDialog = ({ OnRemove }) => {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleRemove = () => {
		setOpen(false);
		OnRemove();
		// OnRemoveVehicle();
	}


	return (
		<div>
			<Tooltip title='Remove from Alert'>
				<IconButton aria-label="delete" onClick={handleClickOpen}>
					<RemoveIcon color="secondary" />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{"Remove Vehicle?"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Remove the Vehicle from this Alert?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleRemove} color="primary">
						Confirm Remove
					</Button>
				</DialogActions>
			</Dialog>
		</div >
	);
};

export default RemoveDialog;
